import { ICoordinate } from 'Context/SuppliersContext';

// Calculates the distance between 2 points on earth according to Haversine function.
export function getHaversineDistance(
  coordinate1: ICoordinate,
  coordinate2: ICoordinate
) {
  const toRadians = (degrees: number): number => {
    return (degrees * Math.PI) / 180;
  };

  const EarthRadius = 6371e3;
  const latitude1 = toRadians(coordinate1.latitude);
  const latitude2 = toRadians(coordinate2.latitude);
  const deltaLatitude = toRadians(coordinate2.latitude - coordinate1.latitude);
  const deltaLongitude = toRadians(
    coordinate2.longitude - coordinate1.longitude
  );

  const centralAngle: number =
    Math.sin(deltaLatitude / 2) * Math.sin(deltaLatitude / 2) +
    Math.cos(latitude1) *
      Math.cos(latitude2) *
      Math.sin(deltaLongitude / 2) *
      Math.sin(deltaLongitude / 2);

  const DistanceBetween2PointsSphere =
    2 * Math.atan2(Math.sqrt(centralAngle), Math.sqrt(1 - centralAngle));

  const distance = EarthRadius * DistanceBetween2PointsSphere;
  return distance;
}
